import { render, staticRenderFns } from "./GoogleDriveSettings.vue?vue&type=template&id=20199eb9"
import script from "./GoogleDriveSettings.vue?vue&type=script&lang=ts"
export * from "./GoogleDriveSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports